import type { AnalyticsEvent } from '../types';

const STORAGE_KEY = 'parkplus_prototype_events';
const MAX_EVENTS = 1000;

class AnalyticsBus {
  private listeners: Set<(event: AnalyticsEvent) => void> = new Set();

  emit(name: string, payload?: Record<string, string | number | boolean | null | undefined>) {
    const event: AnalyticsEvent = {
      name,
      payload,
      timestamp: Date.now(),
    };

    // Console log for live review
    // eslint-disable-next-line no-console
    console.log('[Analytics]', event.name, event.payload);

    // Persist to localStorage for export
    try {
      const existing = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') as AnalyticsEvent[];
      existing.push(event);
      if (existing.length > MAX_EVENTS) existing.shift();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
    } catch {
      // localStorage may be disabled; ignore.
    }

    this.listeners.forEach((listener) => listener(event));
  }

  subscribe(listener: (event: AnalyticsEvent) => void) {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  getEvents(): AnalyticsEvent[] {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') as AnalyticsEvent[];
    } catch {
      return [];
    }
  }

  clear() {
    localStorage.removeItem(STORAGE_KEY);
  }
}

export const analytics = new AnalyticsBus();
